import { render, staticRenderFns } from "./confirm-remove-dialog.vue?vue&type=template&id=782c5e87&lang=pug&"
import script from "./confirm-remove-dialog.vue?vue&type=script&lang=ts&"
export * from "./confirm-remove-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports